import * as __WEBPACK_EXTERNAL_MODULE__assert_index_js_255db76f__ from "../assert/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__helpers_index_js_05b31be6__ from "../helpers/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__encodeBase64_index_js_31848ba6__ from "../encodeBase64/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__composeURLSearch_index_js_65b9783f__ from "../composeURLSearch/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__withoutEmptyProps_index_js_d6018ac7__ from "../withoutEmptyProps/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__request_index_js_fa8e6aed__ from "../request/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__RequestError_js_64c327d7__ from "./RequestError.js";
function tryGetJsonResponse(textResponse) {
    try {
        return JSON.parse(textResponse);
    } catch  {
        throw new Error(`Can't parse server response: ${(0, __WEBPACK_EXTERNAL_MODULE__encodeBase64_index_js_31848ba6__.encodeBase64)(textResponse)}`);
    }
}
function logAndThrowError(error, textResponse, captureEvent = __WEBPACK_EXTERNAL_MODULE__helpers_index_js_05b31be6__.noop, mapErrorCode = __WEBPACK_EXTERNAL_MODULE__helpers_index_js_05b31be6__.identity) {
    if (null == error ? void 0 : error.errorCode) {
        captureEvent(error);
        throw new __WEBPACK_EXTERNAL_MODULE__RequestError_js_64c327d7__.RequestError(mapErrorCode(error.errorCode), error.errorDetails, error.message);
    }
    if (error) {
        captureEvent(error);
        throw new Error(error.message || error);
    }
    const message = `Bad server response: ${(0, __WEBPACK_EXTERNAL_MODULE__encodeBase64_index_js_31848ba6__.encodeBase64)(textResponse)}`;
    captureEvent(message);
    throw new Error(message);
}
function createHttpRequest({ apiBase, options: defaultOptions, errorInterceptor = __WEBPACK_EXTERNAL_MODULE__request_index_js_fa8e6aed__.logErrorWithOnlineCheck, mapErrorCode = __WEBPACK_EXTERNAL_MODULE__helpers_index_js_05b31be6__.identity, captureEvent = __WEBPACK_EXTERNAL_MODULE__helpers_index_js_05b31be6__.noop, onBeforeRequest, onUnauthorized, onSuccess, onError }) {
    function responseInterceptor(response, method) {
        if (401 === response.status || 403 === response.status) {
            null == onUnauthorized || onUnauthorized(response);
            throw new Error('Unauthorized');
        }
        if (response.status >= 500 || 404 === response.status) null == onError || onError(response);
        if ('application/octet-stream' === response.headers.get('Content-Type')) return response.blob().then((blob)=>{
            null == onSuccess || onSuccess(response);
            return blob;
        }).catch((error)=>{
            throw new Error(error.message || error);
        });
        return response.text().then((textResponse)=>{
            if ('{}' === textResponse || 'null' === textResponse) throw new Error('Empty server response');
            if (response.ok && 'HEAD' === method) return true;
            const { success, error, content } = tryGetJsonResponse(textResponse);
            if (true === success) {
                null == onSuccess || onSuccess(response);
                return content;
            }
            logAndThrowError(error, textResponse, captureEvent, mapErrorCode);
        });
    }
    const httpRequest = (httpMethod)=>(endpoint, data, localOptions, dtoMapper = __WEBPACK_EXTERNAL_MODULE__withoutEmptyProps_index_js_d6018ac7__.withoutEmptyProps)=>{
            (0, __WEBPACK_EXTERNAL_MODULE__assert_index_js_255db76f__.assert)(!!endpoint, '(api/httpRequest): Expected a valid endpoint');
            (0, __WEBPACK_EXTERNAL_MODULE__assert_index_js_255db76f__.assert)(endpoint.startsWith('/'), '(api/httpRequest): Expected endpoint to start with /');
            const url = `${apiBase}${endpoint}`;
            const options = {
                credentials: 'include',
                method: httpMethod,
                ...defaultOptions ?? {},
                ...localOptions ?? {},
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache',
                    Accept: '*/*',
                    ...(null == defaultOptions ? void 0 : defaultOptions.headers) ?? {},
                    ...(null == localOptions ? void 0 : localOptions.headers) ?? {}
                }
            };
            if (data instanceof FormData) {
                var _options_headers;
                options.body = data;
                null === (_options_headers = options.headers) || void 0 === _options_headers || delete _options_headers['Content-Type'];
            } else if (data) options.body = JSON.stringify(dtoMapper(data));
            const updatedRequestData = null == onBeforeRequest ? void 0 : onBeforeRequest(url, options);
            return (0, __WEBPACK_EXTERNAL_MODULE__request_index_js_fa8e6aed__.request)((null == updatedRequestData ? void 0 : updatedRequestData.url) ?? url, (null == updatedRequestData ? void 0 : updatedRequestData.options) ?? options, responseInterceptor, errorInterceptor);
        };
    const makeGetRequest = (httpMethod)=>(endpoint, data, localOptions)=>httpRequest(httpMethod)(`${endpoint}${(0, __WEBPACK_EXTERNAL_MODULE__composeURLSearch_index_js_65b9783f__.composeURLSearch)(data)}`, null, localOptions);
    return {
        head: makeGetRequest('HEAD'),
        get: makeGetRequest('GET'),
        delete: httpRequest('DELETE'),
        patch: httpRequest('PATCH'),
        post: httpRequest('POST'),
        put: httpRequest('PUT')
    };
}
export { createHttpRequest };
